import Cookies from 'js-cookie'
import { getUserIdFromCookie } from "@/utils/responsive/utils";

export const initAppDataKeyValues = (navigationMetaInfosConfigs, octipasPayload, trackingUrlFapi, currentPage, mvcUrl, isDQENormalisationActive, shopCircleVersion, logoVersion, olapicConfig = null, context = '', availabilityDisplayMode = '', isWebloyaltyActive = false, deviceType = 'Default', productId) => {
    appData = appData || {}
    appData.navigationMetaInfosConfigs = navigationMetaInfosConfigs;
    appData.sparkowUserIdPatternName = 'cuserid';
    appData.currentPage = currentPage;
    appData.isDQENormalisationActive = isDQENormalisationActive;
    appData.webUserId = getUserIdFromCookie();
    appData.shopCircleVersion = shopCircleVersion;
    appData.mvcUrl = mvcUrl;
    appData.sparkowUserIdCookieName = 'CUserID';
    appData.trackingUrlFapi = trackingUrlFapi;
    appData.octipasCuserId = Cookies.get('CUserID');
    appData.octipasPayload = octipasPayload;
    appData.logoVersion = logoVersion;
    appData.isWebloyaltyActive = isWebloyaltyActive;
    appData.deviceType = deviceType;
    appData.context = context;
    appData.availabilityDisplayMode = availabilityDisplayMode;
    appData.olapicConfig = olapicConfig;
    appData.productId = productId;
    // appData.id= id;
}